import { HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AccessControlService } from 'src/@services/access-control.service';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/shared/enum';
import {
  LOCAL_STORAGE_PORT,
  StoragePort,
} from 'src/@shared/shared/providers';
import { PartyDomainService } from './services/party-domain.service';
import { ReportsDomainService } from './services/reports-domain.service';
import { UsersDomainService } from './services/users-domain.service';
import { InvestmentsDomainService } from './services/investments-domain.service';
import { TagsDomainService } from './services/tags-domain.service';
import { ActivityDomainService } from './services/activity-domain.service';
@Injectable({
  providedIn: 'root',
})
export class InnerPagesService {
  rolePermissions: any;
  supplierRolePermissions: any;
  siteName: string = '';
  siteProcessFee: number = 0;
  currentData: any;
  isCompleted = false;
  currentUrl: string;
  previousUrl: string;
  constructor(
    private _cS: CommonService,
    private _router: Router,
    private usersDomainService: UsersDomainService,
    private partyDomainService: PartyDomainService,
    private reportsDomainService: ReportsDomainService,
    private investmentsDomainService: InvestmentsDomainService,
    private tagsDomainService: TagsDomainService,
    private activityDomainService: ActivityDomainService,
    private accessControlService: AccessControlService,
    @Inject(LOCAL_STORAGE_PORT) private localStoragePort: StoragePort
  ) {
    this.currentUrl = this._router.url;
    _router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }
  public getPreviousUrl() {
    return this.previousUrl;
  }
  /*users*/
  getUsers(requestBody) {
    return this.usersDomainService.getUsers(requestBody);
  }

  //upload delete file
  fileUpload(userBody: any) {
    return this._cS.API_POSTFileUpload(EndPoints.uploadFile, userBody);
  }

  fileDelete(userBody: any) {
    return this._cS.API_POST(EndPoints.deleteFile, userBody);
  }

  UpdateUserProfile(userBody: any) {
    return this.usersDomainService.updateUserProfile(userBody);
  }

  manageProfilePicture(formData: FormData) {
    return this.usersDomainService.manageProfilePicture(formData);
  }

  getUserRecord(userId: any) {
    return this.usersDomainService.getUserRecord(userId);
  }
  //delete unit
  deleteUser(userId: any) {
    return this.usersDomainService.deleteUser(userId);
  }

  reInviteUser(userId: string) {
    return this.usersDomainService.reInviteUser(userId);
  }
  /*roles*/
  getAllRoles(_roleBody: any) {
    return this.usersDomainService.getAllRoles();
  }

  getRolePermissionsDetailsFromLocalStorage() {
    this.rolePermissions = JSON.parse(
      this.localStoragePort.getItem('RolePermissions') || '[]'
    );
  }

  getSupplierRolePermissionsDetailsFromLocalStorage() {
    this.supplierRolePermissions = JSON.parse(
      this.localStoragePort.getItem('SupplierRolePermissions') || '[]'
    );
  }

  getUserSites() {
    return this.usersDomainService.getUserSites();
  }

  // getUserAccountsSites() {
  //   return this._cS.API_GET(EndPoints.GetUserAccountsSites, false);
  // }

  //Code added by Dev (30-04-25)
  getUserAccountsSites(searchText: string = '') {
    return this._cS.API_GET(
      EndPoints.GetAccountSupplierAndSupplierBank + '?searchText=' + searchText,
      false
    );
  }

  getSiteAgencyDetails(siteId: any) {
    return this._cS.API_GET(
      EndPoints.GetSiteAndAgencyDetails + `?siteId=${siteId}`,
      false
    );
  }

  /*notifications*/
  getNotificationsDetails(siteId: any) {
    return this._cS.API_GET(
      EndPoints.GetNotificationDetails + `/${siteId}`,
      false
    );
  }

  updateNotificationRecord(applyToAll: any, notificationDetails: any) {
    return this._cS.API_POST(
      EndPoints.UpdateNotificationRecord + `/${applyToAll}`,
      notificationDetails,
      false
    );
  }

  /*programs*/
  getAllPrograms(requestBody: any) {
    return this._cS.API_POST(EndPoints.GetAllPrograms, requestBody, false);
  }
  deleteProgram(programId: any) {
    return this._cS.API_DELETE(EndPoints.DeleteProgram + `/${programId}`);
  }
  makeProgramDefault(formData: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.makeProgramDefault, formData, false, {
      headers: hd,
    });
  }
  updateProgramVisible(formData: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.UpdatePorgramVisible, formData, false, {
      headers: hd,
    });
  }

  /*Vendors*/
  getAllAddedVendors(
    siteId: any,
    page: any,
    pageSize: any,
    sortBy: any,
    sortField: any
  ) {
    return this.partyDomainService.getAllAddedVendors(
      siteId,
      page,
      pageSize,
      sortBy,
      sortField
    );
  }

  deleteVendor(vendorId: any) {
    return this.partyDomainService.deleteVendor(vendorId);
  }

  searchInDatabase(searchText: any, siteId: any) {
    return this.partyDomainService.searchInDatabase(searchText, siteId);
  }

  editVendor(requestBody: any) {
    return this.partyDomainService.editVendor(requestBody);
  }

  AddVendorFromDB(formdata: any) {
    return this.partyDomainService.addVendorFromDB(formdata);
  }

  /*site*/
  getSiteNonAlcBalance(siteId: any) {
    return this.partyDomainService.getSiteNonAlcBalance(siteId);
  }
  /*Investors*/
  getAllAddedInvestors(requestBody: any) {
    return this.partyDomainService.getAllAddedInvestors(requestBody);
  }

  deleteInvestor(investorId: any) {
    return this.partyDomainService.deleteInvestor(investorId);
  }

  exportInvestorsToExcel(body: any) {
    return this.partyDomainService.exportInvestorsToExcel(body);
  }

  exportVendorsToExcel(siteId: string) {
    return this.partyDomainService.exportVendorsToExcel(siteId);
  }

  searchInDatabaseInvestor(searchText: any, siteId: any) {
    return this.partyDomainService.searchInDatabaseInvestor(searchText, siteId);
  }

  AddInvestorFromDB(formdata: any) {
    return this.partyDomainService.addInvestorFromDB(formdata);
  }

  getInvestorsForDropdown(siteId: any, searchText: string) {
    return this.partyDomainService.getInvestorsForDropdown(siteId, searchText);
  }

  getInvestorDetails(investorId: any) {
    return this.partyDomainService.getInvestorDetails(investorId);
  }

  /*investments*/
  getInvestments(
    siteId: any,
    InvestorId: any,
    searchText: any,
    sortOrder: any,
    sortField: any,
    page: any,
    pageSize: any,
    filterByStatus: any
  ) {
    return this.investmentsDomainService.getInvestments(
      siteId,
      InvestorId,
      searchText,
      sortOrder,
      sortField,
      page,
      pageSize,
      filterByStatus
    );
  }

  confirmInvestment(formdata: any) {
    return this.investmentsDomainService.confirmInvestment(formdata);
  }

  editPDFFiles(file: any, page: any, EditAction: any, rotateDeg: any) {
    return this.investmentsDomainService.editPdfFiles(file, page, EditAction, rotateDeg);
  }

  getVendorDropdownList(siteId: any, searchText: string) {
    return this.investmentsDomainService.getVendorDropdownList(siteId, searchText);
  }
  getVendorDetails(vendorId: any) {
    return this.investmentsDomainService.getVendorDetails(vendorId);
  }

  schedulePayment(paymentData: any) {
    return this.investmentsDomainService.schedulePayment(paymentData);
  }

  getPaymentDetails(paymentId: any) {
    return this.investmentsDomainService.getPaymentDetails(paymentId);
  }

  getInvestmentHistory(investorId: any, siteId: any) {
    return this.investmentsDomainService.getInvestmentHistory(investorId, siteId);
  }

  /*tags*/
  getAllTags(requestBody: any) {
    return this.tagsDomainService.getAllTags(requestBody);
  }

  getTagsDropdownList(siteId: any) {
    return this.tagsDomainService.getTagsDropdownList(siteId);
  }

  logOut(): Observable<any> {
    // 1) First call: no custom headers, interceptor will inject `BearerToken`
    const firstCall$ = this._cS.API_GET(EndPoints.LogOut, false);

    // 2) Prepare second call: only if SupplierBearerToken exists
    const supplierToken = this.localStoragePort.getItem('SupplierBearerToken');
    if (supplierToken) {
      const headers = new HttpHeaders().set(
        'Authorization',
        `Bearer ${supplierToken}`
      );
      const secondCall$ = supplierToken
        ? this._cS.API_GET(EndPoints.LogOut, false, { headers })
        : of(null); // no-op if no supplier token

      // Chain them: firstCall$ → then secondCall$, emitting only when both complete
      return firstCall$.pipe(switchMap(() => secondCall$));
    } else {
      return firstCall$;
    }
  }

  // logOut() {
  //   return this._cS.API_GET(EndPoints.LogOut, false);
  // }

  addTagGroup(tagGroupData: any) {
    return this.tagsDomainService.addTagGroup(tagGroupData);
  }
  updateTagGroup(tagGroupData: any) {
    return this.tagsDomainService.updateTagGroup(tagGroupData);
  }
  deleteTagGroup(groupId: any) {
    return this.tagsDomainService.deleteTagGroup(groupId);
  }
  addTag(tagData: any) {
    return this.tagsDomainService.addTag(tagData);
  }
  updateTag(tagData: any) {
    return this.tagsDomainService.updateTag(tagData);
  }
  deleteTag(groupId: any, tagId: any) {
    return this.tagsDomainService.deleteTag(groupId, tagId);
  }

  getTagGroupNameList(siteId: any) {
    return this.tagsDomainService.getTagGroupNameList(siteId);
  }

  getUserProfileData() {
    return this.tagsDomainService.getUserProfileData();
  }

  updateProfileData(profileData: any) {
    return this.tagsDomainService.updateProfileData(profileData);
  }
  getPrintDeatilsLink(
    transactionsId: any,
    transactionType: any,
    transactionSubType: any
  ) {
    return this.activityDomainService.getPrintDetailsLink(
      transactionsId,
      transactionType,
      transactionSubType
    );
  }
  /*get activities */
  getActvityRecords(
    siteId: any,
    startPeriod: any,
    endPeriod: any,
    searchText: any,
    programPeriodId: any,
    tagIds: any,
    TransactionSubType: any,
    activityType: any,
    sortOrder: any,
    sortField: any,
    page: any,
    pageSize: any,
    isNonAlc: boolean
  ) {
    return this.activityDomainService.getActivityRecords(
      siteId,
      startPeriod,
      endPeriod,
      searchText,
      programPeriodId,
      tagIds,
      TransactionSubType,
      activityType,
      sortOrder,
      sortField,
      page,
      pageSize,
      isNonAlc
    );
  }
  getActvityRecordsV2(
    siteId: any,
    startPeriod: any,
    endPeriod: any,
    searchText: any,
    TransactionSubType: any,
    activityType: any,
    sortOrder: any,
    sortField: any,
    page: any,
    pageSize: any,
    isNonAlc: boolean,
    filterCompany: any,
    filterStatus: any,
    filterTransactions: any,
    filterProgram: any,
    filterTag: any
  ) {
    return this.activityDomainService.getActivityRecordsV2(
      siteId,
      startPeriod,
      endPeriod,
      searchText,
      TransactionSubType,
      activityType,
      sortOrder,
      sortField,
      page,
      pageSize,
      isNonAlc,
      filterCompany,
      filterStatus,
      filterTransactions,
      filterProgram,
      filterTag
    );
  }
  getActivityCounts(siteId: any) {
    return this.activityDomainService.getActivityCounts(siteId);
  }
  getActivitiesCounts(requestBody: any) {
    return this.activityDomainService.getActivitiesCounts(requestBody);
  }
  getSummary(siteId: any) {
    return this.reportsDomainService.getSummary(siteId);
  }
  getResources() {
    return this.reportsDomainService.getResources();
  }

  contactInvestor(requestBody: any) {
    return this.activityDomainService.contactInvestor(requestBody);
  }

  //reports
  getLast24Months(siteId: any) {
    return this.reportsDomainService.getLast24Months(siteId);
  }

  getAccountStatements(siteId: any, year: any, month: any) {
    return this.reportsDomainService.getAccountStatements(siteId, year, month);
  }
  getOutstandingInvoices(siteId: any) {
    return this.reportsDomainService.getOutstandingInvoices(siteId);
  }
  //reports
  getActivityExport(siteId: any, startPeriod: any, endPeriod: any) {
    return this.reportsDomainService.getActivityExport(siteId, startPeriod, endPeriod);
  }
  getProgramReport(siteId: any, includeTagCategory: boolean) {
    return this.reportsDomainService.getProgramReport(siteId, includeTagCategory);
  }

  getInvestmentProgramReport(siteId: string) {
    return this.reportsDomainService.getInvestmentProgramReport(siteId);
  }

  getInvestmentActivityByCalendarYearExport(
    siteId: string,
    calendarYear: number | string,
    startPeriod: string,
    endPeriod: string
  ) {
    return this.reportsDomainService.getInvestmentActivityByCalendarYearExport(
      siteId,
      calendarYear,
      startPeriod,
      endPeriod
    );
  }

  //announcement
  getAnnouncements(siteId: any) {
    return this.activityDomainService.getAnnouncements(siteId);
  }

  clearAnnouncements(requestBody: any) {
    return this.activityDomainService.clearAnnouncements(requestBody);
  }

  openViewInvoiceURL(transactionsId: any, transactionsType: any) {
    return this.activityDomainService.openViewInvoiceURL(transactionsId, transactionsType);
  }
  getInvoicePdf(qboInvoiceId: string, investmentType: number) {
    return this.activityDomainService.getInvoicePdf(qboInvoiceId, investmentType);
  }
  GetUserAccountsSites() {
    return this._cS.API_GET(EndPoints.GetUserAccountsSites, false);
  }

  //check if current user can access users
  canAccessUsers() {
    return this.accessControlService.canAccessUsers();
  }

  isInternalRoleUser() {
    return this.accessControlService.isInternalRoleUser();
  }

  //check if current user can access payments
  canAccessPayments() {
    return this.accessControlService.canAccessPayments();
  }

  canAccessInvestments() {
    return this.accessControlService.canAccessInvestments();
  }

  canAccessSummary() {
    return this.accessControlService.canAccessSummary();
  }
  canAccessActivity() {
    return this.accessControlService.canAccessActivity();
  }
  canAccessInvestors() {
    return this.accessControlService.canAccessInvestors();
  }
  canAccessVendors() {
    return this.accessControlService.canAccessVendors();
  }
  canAccessTags() {
    return this.accessControlService.canAccessTags();
  }
  canAccessProgramsTags() {
    return this.accessControlService.canAccessProgramsTags();
  }
  canAccessTutorials() {
    return this.accessControlService.canAccessTutorials();
  }
  canAccessNotifications() {
    return this.accessControlService.canAccessNotifications();
  }
  canAccessReports() {
    return this.accessControlService.canAccessReports();
  }

  canAccessProjections() {
    return this.accessControlService.canAccessProjections();
  }

  canViewProjections() {
    return this.accessControlService.canViewProjections();
  }

  /**
   * Returns the best landing route for a given siteId based on the user's
   * Paybev role permissions. Walks modules in priority order so that
   * Investment-only or Expense-only users land on their allowed page
   * instead of my-profile.
   */
  getPermissionBasedLandingRoute(siteId: string): string {
    const base = `paybev/${siteId}`;
    const ac = this.accessControlService;
    const ordered = [
      { permission: !!ac.canAccessSummary().canViewSummary, path: 'summary' },
      { permission: !!ac.canAccessActivity().canViewActivity, path: 'activity-detailed' },
      { permission: !!ac.canAccessInvestments().canViewInvestments, path: 'investments' },
      { permission: !!ac.canAccessPayments().canAddPayment, path: 'payments' },
      { permission: !!ac.canAccessReports(), path: ac.getFirstReportsLandingPath() },
    ];
    const match = ordered.find((entry) => entry.permission);
    return match ? `${base}/${match.path}` : `${base}/my-profile`;
  }

  canAccessSupplierSummary() {
    this.getSupplierRolePermissionsDetailsFromLocalStorage();
    let canViewSummary, canAddSummary, canDeleteSummary;
    const summaryDetails = this.supplierRolePermissions[0];
    const index = summaryDetails?.permissions?.findIndex(
      (obj: any) => obj.module == 'Summary'
    );

    if (index != undefined && index != -1) {
      canViewSummary = summaryDetails.permissions[index].canView;
      canAddSummary = summaryDetails.permissions[index].canAdd;
      canDeleteSummary = summaryDetails.permissions[index].canDelete;
    }

    return {
      canViewSummary,
      canAddSummary,
      canDeleteSummary,
    };
  }

  canAccessSupplierPrograms() {
    this.getSupplierRolePermissionsDetailsFromLocalStorage();
    let canViewPrograms, canAddPrograms, canDeletePrograms;
    const programsDetails = this.supplierRolePermissions[2];
    const index = programsDetails?.permissions?.findIndex(
      (obj: any) => obj.module == 'RetailProgram'
    );

    if (index != undefined && index != -1) {
      canViewPrograms = programsDetails.permissions[index].canView;
      canAddPrograms = programsDetails.permissions[index].canAdd;
      canDeletePrograms = programsDetails.permissions[index].canDelete;
    }

    return {
      canViewPrograms,
      canAddPrograms,
      canDeletePrograms,
    };
  }

  //Code Added by Dev Dasani (08/04/2025)
  getAssignmentAndAgreementDetails() {
    return this.investmentsDomainService.getAssignmentAndAgreementDetails();
  }

  getActivityFilters(
    siteId: any,
    startPeriod: any,
    endPeriod: any,
    searchText: any,
    TransactionSubType: any,
    activityType: any,
    sortOrder: any,
    sortField: any,
    page: any,
    pageSize: any,
    isNonAlc: boolean,
    filterStatus: any
  ) {
    return this.activityDomainService.getActivityFilters(
      siteId,
      startPeriod,
      endPeriod,
      searchText,
      TransactionSubType,
      activityType,
      sortOrder,
      sortField,
      page,
      pageSize,
      isNonAlc,
      filterStatus
    );
  }
}
